import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';

import Translate from '@client/components/shared/translation/Translate';
import { getQueryParam } from '@client/helpers/getQueryParam';
import { LoaderIcon } from '@client/components/shared/SvgIcons';
import { getWebviewOs } from '@client/redux/modules/clientDevice/selectors';
import { injectConfig, configShape } from '@client/hoc/config';

import { incomingMessage } from '../../helpers/nanorep';

import styles from './helpPage.scss';


const PATH_QUERY_PARAM = 'path';

export class HelpPage extends React.Component {
    state = {
        loading: true,
        iframeLoading: true,
    }

    render() {
        const { helpDeepLink } = this;
        const {
            isWebview,
            intl,
        } = this.props;

        const {
            loading,
            iframeLoading,
        } = this.state;

        const loader = (
            <div>
                <LoaderIcon styleName="loader-icon" />
                <div styleName="text-wrapper">
                    <Translate message="shared.loadingMessage" />
                </div>
            </div>
        );

        return (
            <div styleName={classNames('wrapper', { 'wrapper-non-mobile': !isWebview })}>
                {isWebview && <Helmet title={intl.formatMessage({ id: 'header.myAccountNav.help' })} />}
                {loading ?
                    loader
                    :
                    <div>
                        {iframeLoading && loader}
                        <iframe
                            styleName={classNames({
                                'help-iframe': !isWebview,
                                'help-iframe--webview': isWebview
                            })}
                            onLoad={this.onIframeLoad}
                            src={helpDeepLink}
                            id="supportFrame"
                            style={{ visibility: iframeLoading ? 'hidden' : 'visible' }}
                        >
                        </iframe>
                    </div>
                }
            </div>
        );
    }

    componentDidMount() {
        if (window.addEventListener) {
            window.addEventListener('message', incomingMessage, false);
        }
        else if (window.attachEvent) {
            window.attachEvent('onmessage', incomingMessage);
        }

        if (document.readyState !== 'complete') {
            window.addEventListener('load', this.onLoad);
        }
        else {
            this.onLoad();
        }
    }

    onLoad = () => {
        this.setState({ loading: false });
    }

    onIframeLoad = () => {
        this.setState({ iframeLoading: false });
    }

    get helpDeepLink() {
        const { config } = this.props;
        const path = getQueryParam(this.props.location.search, PATH_QUERY_PARAM);

        return path ? `${config.help_link}/${path.replace('/', '')}` : config.help_link;
    }
}

HelpPage.propTypes = {
    isWebview: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    config: configShape,
    intl: PropTypes.object,
};


const mapStateToProps = (state) => ({
    isWebview: !!getWebviewOs(state)
});

export default injectConfig(
    connect(
        mapStateToProps, {}
    )(
        injectIntl(
            CSSModules(HelpPage, styles, { allowMultiple: true })
        )
    )
);

